import { createBrowserRouter } from "react-router";
import { createElement } from "react";
import RootRoute from "./RootRoute";
import { setCurrentLocation, currentLocation } from "routes/currentLocation";

export const router = createBrowserRouter([
  {
    path: "*",
    element: createElement(RootRoute)
  }
]);

setCurrentLocation(router.state.location);
router.subscribe(state => setCurrentLocation(state.location));

export { currentLocation };
